import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Button, Heading, Text } from '@spothero/ui';
import EventInfo from 'common/event-package-info/event-info';
import Price from 'common/price';
import sortBy from 'lodash/sortBy';
import { PROPTYPE_EVENT_PACKAGE_EVENT } from '@/proptypes/index';
import { useShowTotal } from 'store/selectors/hooks/useShowTotal';
const NUMBER_OF_PREVIEW_EVENTS = 3;
const EventPrices = ({ events, timezone }) => {
    const showTotal = useShowTotal();
    // sort events to make sure they are in chronological order
    const sortedEvents = sortBy(events, [
        event => event.starts.replace(/\D/g, ''),
    ]);
    const [showFullEventList, setShowFullEventList] = useState(sortedEvents.length <= NUMBER_OF_PREVIEW_EVENTS);
    const toggleFullEventList = () => setShowFullEventList(show => !show);
    const eventsToShow = showFullEventList
        ? sortedEvents
        : sortedEvents.slice(0, NUMBER_OF_PREVIEW_EVENTS);
    return (<Box position="relative" margin="4" paddingTop="4" borderTopColor="gray.medium" borderTopWidth="1px">
            <Heading as="h3" variant="h5" marginBottom="4">
                Parking Included
            </Heading>
            <Box>
                {eventsToShow.map(event => {
            let rentalPrice = 0;
            const price = event.price;
            if (showTotal) {
                // Reduce down with fees - Assumption made no discounts are in the breakdown, only fees
                rentalPrice = price.priceBreakdown.reduce((prev, curr) => {
                    return prev + curr.price;
                }, 0);
            }
            else {
                // just get the price of the rental without any fees
                rentalPrice = price.priceBreakdown.find(rate => {
                    return rate.type === 'rental';
                })?.price;
            }
            return (<Flex key={event.id} justifyContent="space-between" data-testid="EventListItem">
                            <EventInfo event={event} timezone={timezone}/>
                            <Text fontSize="base" fontWeight="semibold">
                                <Price amount={rentalPrice} currencyType={price.currencyCode} showCents/>
                            </Text>
                        </Flex>);
        })}
                {!showFullEventList && (<Box position="absolute" bottom="6" left="0" width="100%" height="12" background="linear-gradient(180deg, transparent, white)"/>)}
            </Box>
            {!showFullEventList && (<Box backgroundColor="white" textAlign="center" lineHeight="1.5">
                    <Button variant="tertiary" onClick={toggleFullEventList}>
                        Show All {sortedEvents.length} Events
                    </Button>
                </Box>)}
        </Box>);
};
EventPrices.propTypes = {
    events: PropTypes.arrayOf(PROPTYPE_EVENT_PACKAGE_EVENT).isRequired,
    timezone: PropTypes.string.isRequired,
};
export default EventPrices;
